<nb-card status="info">
  <nb-card-header>
    <div class="row">
      <div class="col-sm-10">
        <strong>Alteração de Senha Obrigatória</strong>
      </div>
      <div class="col-sm-2 d-flex justify-content-end">
        <!-- <button nbSuffix nbButton (click)="close()" size="tiny" status="danger">
          <nb-icon icon="close-outline"></nb-icon>
        </button> -->
      </div>
    </div>
  </nb-card-header>
  
  <nb-card-body>
    <p>
      Por motivos de segurança, é necessário que você altere sua senha agora.
    </p>
    <p>
      Sua senha foi redefinida pelo administrador e, para garantir a proteção do seu acesso, 
      você precisa definir uma nova senha personalizada.
    </p>
    <p>
      Escolha uma senha segura e fácil de lembrar.  
    </p>
    
      <div class="row">
        <div class="col-sm-5">
          <label for="inputNvaSenha">Nova Senha</label>
          <nb-form-field>
            <input nbInput fullWidth
              name="password"
              [type]="hide ? 'password':'text'"
              id="inputNvaSenha"
              placeholder="Senha"
              status="basic" 
              fieldSize="small"
              tabindex="2"
              shape="semi-round" 
              [(ngModel)]="senha">
            <button nbSuffix nbButton ghost (click)="hide = !hide" tabindex="-1"
              style="pointer-events: auto;"
              (focus)="onFocus($event)">
              <nb-icon [icon]="hide ? 'eye-off-2-outline' : 'eye-outline'"
                      pack="eva"
                      [attr.aria-label]="hide ? 'hide password' : 'show password'">
              </nb-icon>
            </button>
          </nb-form-field>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-5">
          <label for="inputConfirmeSenha">Confirmar a Senha</label>
          <nb-form-field>
            <input nbInput fullWidth
              name="confirmPassword"
              [type]="hide2 ? 'password':'text'"
              id="inputConfirmeSenha"
              placeholder="Senha"
              status="basic" 
              fieldSize="small"
              tabindex="2"
              shape="semi-round" 
              [(ngModel)]="confirmarSenha">
            <button nbSuffix nbButton ghost (click)="hide2 = !hide2" tabindex="-1"
              style="pointer-events: auto;"
              (focus)="onFocus($event)">
              <nb-icon [icon]="hide2 ? 'eye-off-2-outline' : 'eye-outline'"
                      pack="eva"
                      [attr.aria-label]="hide2 ? 'hide2 confirmPassword' : 'show confirmPassword'">
              </nb-icon>
            </button>
          </nb-form-field>
        </div>
      </div>

    <div class="row mt-3">
      <div class="col-sm-12">
        <div class="password-requirements erro-email" *ngIf="bloquearBotaoAlterarSenha() && senha !== null && senha !== ''">
          <h3>Requisitos para a senha:</h3>
            <ul>
              <li>Deve conter <strong>pelo menos 8 caracteres</strong>.</li>
              <li>Deve incluir <strong>ao menos uma letra maiúscula</strong> (A-Z).</li>
              <li>Deve incluir <strong>ao menos uma letra minúscula</strong> (a-z).</li>
              <li>Deve conter <strong>pelo menos um símbolo</strong> da lista abaixo:</li>
            </ul>
            <p class="erro-email"><strong>Caracteres especiais permitidos:</strong></p>
            <code>! &amp; #36; % ^ &amp; * ( ) _ + - = &#123; &#125; &#91; &#93; | \ : ; " ' &lt; &gt; , . ? /</code>
            <p class="erro-email">A senha e a <strong>confirmação de senha</strong> devem ser idênticas.</p>
        </div>
      </div>
    </div>
  </nb-card-body>
  
  <nb-card-footer>
    <button nbButton 
      status="primary"
      (click)="trocarSenha()"
      [disabled]="bloquearBotaoAlterarSenha()">Alterar Senha Agora</button>
  </nb-card-footer>
</nb-card>
